import { EMPTY_ACTEUR } from "./../data/acteurAdmin.constants";

export const normalize = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const normalizeDate = (value) => {
  if (!value) return "";
  return String(value).slice(0, 10);
};

export const toAbsoluteAvatar = (url) => {
  if (!url) return "/img/user_avatar.jpg";

  const normalizedUrl = String(url).trim();

  return normalizedUrl || "/img/user_avatar.jpg";
};

export const toActeurForm = (data) => ({
  ...EMPTY_ACTEUR,

  nom: data?.nom || "",
  prenom: data?.prenom || "",
  email: data?.email || "",
  tel: data?.tel || "",
  adresse: data?.adresse || "",
  cp: data?.cp || "",
  commune: data?.commune || "",
  genre: data?.genre || "",

  date_naissance: normalizeDate(data?.date_naissance),

  photo_url: data?.photo_url || "",
  club_acteur: data?.club_acteur || "",
  licence_number: data?.licence_number || "",
  groupe_souhaite: data?.groupe_souhaite || "",
});

const nil = (value) => {
  const normalizedValue = String(value ?? "").trim();

  return normalizedValue || null;
};

export const buildActeurPayload = (data) => ({
  nom: String(data?.nom || "").trim(),
  prenom: String(data?.prenom || "").trim(),

  email: nil(data?.email),
  tel: nil(data?.tel),
  adresse: nil(data?.adresse),
  cp: nil(data?.cp),
  commune: nil(data?.commune),
  genre: nil(data?.genre),

  date_naissance: data?.date_naissance || null,

  photo_url:
    String(data?.photo_url || "").trim() ||
    "/img/user_avatar.jpg",

  club_acteur: nil(data?.club_acteur),
  licence_number: nil(data?.licence_number),
  groupe_souhaite: nil(data?.groupe_souhaite),
});

export const matchesActeurSearch = (
  acteur,
  query,
) => {
  const needle = normalize(query);

  if (!needle) return true;

  const linkedUsers = (acteur?.Users || [])
    .flatMap((user) => [
      user?.nom,
      user?.prenom,
      user?.email,
    ])
    .filter(Boolean);

  const searchableValue = [
    acteur?.nom,
    acteur?.prenom,
    `${acteur?.nom || ""} ${acteur?.prenom || ""}`,
    acteur?.club_acteur,
    acteur?.email,
    acteur?.tel,
    acteur?.groupe_souhaite,
    acteur?.licence_number,
    ...linkedUsers,
  ]
    .filter(Boolean)
    .join(" ");

  return normalize(searchableValue).includes(needle);
};

export const sortActeurs = (acteurA, acteurB) =>
  `${acteurA?.nom || ""} ${
    acteurA?.prenom || ""
  }`.localeCompare(
    `${acteurB?.nom || ""} ${
      acteurB?.prenom || ""
    }`,
    "fr",
    {
      sensitivity: "base",
    },
  );